import config from '../../../config';

const { httpProxy, noProxy } = config;
const noProxyRegEx = (noProxy) ? new RegExp(noProxy) : null;

let httpProxyAgent = false;
if (process.browser !== true && httpProxy) {
    const proxyAgent = require('http-proxy-agent');
    httpProxyAgent = new proxyAgent(httpProxy);
}

export default (request) => {
    // if there's a proxy agent setup
    if (httpProxyAgent && 'agent' in request) {
        // if there's no noProxy regex or the url does not match the noProxy regex
        // then use the proxy
        if (!noProxyRegEx || noProxyRegEx.test(request.url) === false) {
            request.agent(httpProxyAgent);
        }
    }
    return request
}



// WEBPACK FOOTER //
// ./app/lib/api/requestProxy.js